var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.4,
    width: 164,
    height: 164,
    rx: 82,
    fill: "#F8F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 141.44c-20.5 0-38.622-10.496-49.2-26.24.246-16.4 32.8-25.42 49.2-25.42 16.4 0 48.954 9.02 49.2 25.42a59.302 59.302 0 0 1-49.2 26.24zM82.5 25a24.6 24.6 0 1 1 0 49.2 24.6 24.6 0 0 1 0-49.2zm0-24.6a82 82 0 1 0 82 82c0-45.346-36.9-82-82-82z",
    fill: "#D4DAF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user-default.6f61dfe06352a5c738fb3c2d788aa152.svg";
export { ForwardRef as ReactComponent };